var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      ref: "audioSourceSection",
      staticClass: "product-podcast-section vue-inited m-t-20",
      attrs: { id: "product-upload-podcast-section" }
    },
    [
      _vm.isProductForm
        ? _c("input", {
            attrs: { type: "hidden", name: "product[audio_id]" },
            domProps: { value: _vm.audio.id }
          })
        : _c("input", {
            attrs: { type: "hidden", name: "card[audio_id]" },
            domProps: { value: _vm.audio.id }
          }),
      _vm._v(" "),
      _c("div", { staticClass: "m-b-10" }, [
        _c("div", { staticClass: "row" }, [
          _c("div", { staticClass: "col-md-8" }, [
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.audio.source_type,
                  expression: "audio.source_type"
                }
              ],
              staticClass: "radio-custom",
              attrs: { id: "src-file", type: "radio", value: "file" },
              domProps: { checked: _vm._q(_vm.audio.source_type, "file") },
              on: {
                change: function($event) {
                  return _vm.$set(_vm.audio, "source_type", "file")
                }
              }
            }),
            _vm._v(" "),
            _c(
              "label",
              { staticClass: "radio-custom-label", attrs: { for: "src-file" } },
              [_vm._v("Audio File")]
            )
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "col-md-4" }, [
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.audio.source_type,
                  expression: "audio.source_type"
                }
              ],
              staticClass: "radio-custom",
              attrs: { id: "src-url", type: "radio", value: "url" },
              domProps: { checked: _vm._q(_vm.audio.source_type, "url") },
              on: {
                change: function($event) {
                  return _vm.$set(_vm.audio, "source_type", "url")
                }
              }
            }),
            _vm._v(" "),
            _c(
              "label",
              { staticClass: "radio-custom-label", attrs: { for: "src-url" } },
              [_vm._v("URL")]
            )
          ])
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "m-b-30" }, [
        _c(
          "div",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.audio.source_type === "file",
                expression: "audio.source_type === 'file'"
              }
            ]
          },
          [
            _c("podcast-dropzone", {
              attrs: {
                max_size: "500",
                api: _vm.Api,
                "uploaded-podcast": _vm.audio
              },
              on: {
                "update:id": function($event) {
                  _vm.audio.id = $event
                },
                "update:original_url": function($event) {
                  _vm.audio.original_url = $event
                }
              }
            }),
            _vm._v(" "),
            _vm.audio.original_url
              ? _c("Player", {
                  attrs: {
                    source: _vm.player_source,
                    poster: _vm.player_poster
                  }
                })
              : _vm._e()
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.audio.source_type === "url",
                expression: "audio.source_type === 'url'"
              }
            ]
          },
          [
            _c(
              "div",
              {
                staticClass: "form-group form-group40 group-row",
                staticStyle: { position: "relative" }
              },
              [
                _vm._m(0),
                _vm._v(" "),
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.temp_original_url,
                      expression: "temp_original_url"
                    }
                  ],
                  staticClass: "form-control large_body inputs",
                  attrs: {
                    id: "source_url",
                    placeholder: "Paste your URL link here",
                    type: "text"
                  },
                  domProps: { value: _vm.temp_original_url },
                  on: {
                    blur: _vm.onBlurSourceUrl,
                    keyup: function($event) {
                      if (
                        !$event.type.indexOf("key") &&
                        _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                      ) {
                        return null
                      }
                      return _vm.onBlurSourceUrl($event)
                    },
                    input: function($event) {
                      if ($event.target.composing) {
                        return
                      }
                      _vm.temp_original_url = $event.target.value
                    }
                  }
                }),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass: "text-right small",
                    class: { error: _vm.hasError }
                  },
                  [_vm._v(_vm._s(_vm.status))]
                )
              ]
            ),
            _vm._v(" "),
            _vm.embed_url_info.embed_content
              ? _c("div", { staticClass: "card-image-section" }, [
                  _c("div", { staticClass: "media-content" }, [
                    _vm.embed_url_info.provider_name === "YouTube"
                      ? _c(
                          "div",
                          {
                            staticClass: "embed-section",
                            class: {
                              hideIframeVideoCrutch: _vm.playPdYTiframe
                            },
                            style: {
                              "background-image":
                                "url(" + _vm.embed_url_info.img_src + ")"
                            },
                            on: {
                              click: function($event) {
                                _vm.playPdYTiframe = true
                              }
                            }
                          },
                          [
                            !_vm.playPdYTiframe
                              ? _c("i", { staticClass: "fa fa-play-circle" })
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.playPdYTiframe
                              ? _c("div", {
                                  staticClass: "crutch",
                                  domProps: {
                                    innerHTML: _vm._s(
                                      _vm.autoplay_embed_content
                                    )
                                  }
                                })
                              : _vm._e()
                          ]
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _c("div", {
                      staticClass: "embed-section",
                      class: _vm.embed_url_info.provider_name,
                      domProps: {
                        innerHTML: _vm._s(_vm.embed_url_info.embed_content)
                      }
                    })
                  ])
                ])
              : _vm._e()
          ]
        )
      ]),
      _vm._v(" "),
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value:
                _vm.audio.source_type === "file" ||
                !_vm.embed_url_info.embed_content,
              expression:
                "audio.source_type === 'file' || !embed_url_info.embed_content"
            }
          ],
          staticClass: "m-b-30 thumbnails"
        },
        [
          _c("h6", [
            _vm._v("\n                Cover Artwork "),
            _c(
              "i",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.isProductForm,
                    expression: "isProductForm"
                  }
                ],
                staticClass: "small"
              },
              [_vm._v("(preview)")]
            )
          ]),
          _vm._v(" "),
          _c("p", { staticClass: "small" }, [
            _vm._v("Supported formats: JPEG,PNG")
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "thumb-uploaded" }, [
            _vm.audio.poster_original_url
              ? _c("div", {
                  staticClass: "fa fa-trash",
                  attrs: { title: "Remove this thumbnail" },
                  on: {
                    click: function($event) {
                      return _vm.$root.$emit("clearOwnThumbnail")
                    }
                  }
                })
              : _vm._e(),
            _vm._v(" "),
            _c(
              "div",
              { staticStyle: { height: "200px" } },
              [
                _c("thumbnail-dropzone2", {
                  attrs: {
                    elem_id: "dropzone-audio-poster-file",
                    max_size: "10",
                    img_src: _vm.audio.poster_original_url,
                    form_selector: _vm.form_selector
                  },
                  on: {
                    "update:img_src": function($event) {
                      _vm.audio.poster_original_url = $event
                    }
                  }
                })
              ],
              1
            )
          ])
        ]
      )
    ]
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("label", { staticClass: "label-control" }, [
      _c("span", { staticClass: "label-text", staticStyle: { top: "0" } }, [
        _vm._v("URL")
      ])
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }